module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACCSURBVHgBjVJBDYAwDGQLQmYBB+AEJKCAOUECEkDCHIAEHIwr6ZKRlK2XXNK0d70+2sQYR3AFXVNAZFDhuT7JXDPYrOdAStpLaVbo9SClLVpDguczndaQzvyk1QwJRmsIYGeM8TXDDc4Qkjjkg1YQH+AE4SVtssLW4U/8gl9j077GA4UbW4vgj6XlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_player_forward.png
// module id = 77XS
// module chunks = 1